import { makeStyles } from "@fluentui/react-components";

export const useProfileStyles = makeStyles({
  card: {
    width: "100%",
    maxWidth: "100%",
    height: "100%",
  },
  cardFooter: {
    textAlign: "right",
  },
  root: {
    textAlign: "center",
    marginRight: "10px",
    marginLeft: "10px",
    paddingTop: "10px",
  },
  cell: {
    textAlign: "left",
    width: "220px",
  },
  tableContainer: {
    "overflow-y": "auto",
    height: "275px",
  },
  cursorPointer: {
    cursor: "pointer",
  },
  emptyState: {
    display: "block",
    width: "100%",
    boxSizing: "border-box",
    textAlign: "left",
    paddingTop: "60px",
    paddingBottom: "20px",
    paddingLeft: "16px",
    paddingRight: "16px",
  },
  emptyStateText: {
    display: "block",
    marginBottom: "14px",
    overflowWrap: "break-word",
  },
  button: {
    width: "85px",
  },
});
